module.exports = __webpack_public_path__ + "media/images/icons/icon_play_white-d465805f505fd6ec0a5cac52319d2ee2.svg";